// extracted by mini-css-extract-plugin
module.exports = {"title":"RenewMembership_title__alU_J","text":"RenewMembership_text__onOSz","wrapper":"RenewMembership_wrapper__sSFMb"};